export default "__VITE_ASSET__k0FHnCAY__";